import { MessageSquareText, ListChecks, HeartHandshake } from "lucide-react";
import { VALUE_PROPS } from "@/config/site";
import { Reveal } from "@/components/Reveal";

const ICONS = { MessageSquareText, ListChecks, HeartHandshake };

export default function ValueProps() {
  return (
    <section className="section-pad" aria-label="I nostri punti di forza">
      <div className="container-x grid gap-5 sm:grid-cols-3 sm:gap-6">
        {VALUE_PROPS.map((v, i) => {
          const Icon = ICONS[v.icon];
          return (
            <Reveal key={v.id} delay={i * 0.1}>
              <article data-testid={`value-card-${v.id}`} className="card card-hover h-full p-7 sm:p-8">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#edf3ff]">
                  <Icon className="h-5 w-5 text-[#0050e0]" strokeWidth={1.8} />
                </div>
                <h3 className="font-display mt-6 text-xl font-bold tracking-tight text-[#1c1d1f]">{v.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#575a61] sm:text-base">{v.text}</p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
